import TaskCards from '../../api/task_cards';
const taskCards = new TaskCards();

const taskCardsModule = {
    namespaced: true,
    state: {
        loading: false,
        tasks: [],
        totalTasks: 0,
    },
    getters: {
        tasks: (state) => state.tasks,
        totalTasks: (state) => state.totalTasks,
        loading: (state) => state.loading,
    },
    mutations: {
        SET_LOADING: (state, loading) => {
            state.loading = loading;
        },
        SET_TASKS: (state, data) => {
            state.tasks = data;
        },
        SET_TOTAL_TASKS: (state, count) => {
            state.totalTasks = count;
        },
    },
    actions: {
        GetTaskCards({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                taskCards.list(payload.query).then(response => {
                    if (response) {
                        const data = Array.isArray(response) ? response : (response.taskCards || response.task_cards || response.tasks || []);
                        commit('SET_TASKS', data);
                        commit('SET_TOTAL_TASKS', response.total || response.count || data.length || 0);
                    }
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        CreateTaskCard({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                taskCards.store(payload).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        UpdateTaskCard({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                taskCards.update(payload.id, payload.form).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        DeleteTaskCard({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                taskCards.delete(id).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        RestoreTaskCard({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                taskCards.restore(id).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
    }
};

export default taskCardsModule;
